import React from 'react'
import { FormattedMessage } from 'react-intl'
import {
  Container,
  Icon,
  ErrorContainer
} from './StoreErrorPageStyledComponents'
import { Button, Col, Row } from 'reactstrap'
import NewHeader from '../../components/layout/NewHeader/NewHeader'
import { Link, withRouter } from 'react-router-dom'
import map from '../../assets/svg/map.svg'
import PropTypes from 'prop-types'

const StoreNotInGeo = React.memo(({ toggleGeolocationModal }) => (
  <>
    <NewHeader showBreadcrumb={false} showScrollIcon={false}>
      <h1 className='text-center'>
        <FormattedMessage id='storeErrorPage.title' />
      </h1>
    </NewHeader>
    <Container>
      <Row>
        <Col md={{ size: 10, offset: 1 }} className='text-center'>
          <ErrorContainer className='mb-4'>
            <Icon src={map} />
            <p className='text-dark mt-2'>
              <FormattedMessage id='storeErrorPage.locationRequired' />
            </p>
            <p>
              <FormattedMessage id='storeErrorPage.locationRequiredText' />
            </p>
            <Button onClick={toggleGeolocationModal}>
              <FormattedMessage id='geopopover.howToEnableLinkText' />
            </Button>
          </ErrorContainer>
          <Button
            color='secondary'
            className='my-3'
            onClick={() => {
              window.location.reload()
            }}
          >
            <FormattedMessage id='storeErrorPage.reloadStore' />
          </Button>
          <br />
          <Link className='my5' to='/home'>
            <FormattedMessage id='storeErrorPage.text' />
          </Link>
        </Col>
      </Row>
    </Container>
  </>
))

StoreNotInGeo.displayName = 'StoreNotInGeo'

StoreNotInGeo.propTypes = {
  toggleGeolocationModal: PropTypes.func.isRequired
}

export default withRouter(StoreNotInGeo)
